import React from 'react';

function wrapperStyle({ constants }) {
  const keyWidth = constants.KEYFORM_KEY_HEIGHT * 3;
  const spacerWidth = constants.KEYFORM_SPACER_SIZE * 2;

  return {
    width: keyWidth + spacerWidth
  };
}

function squareStyle({ constants }) {
  return {
    width: constants.KEYFORM_SPACER_SIZE,
    height: constants.KEYFORM_SPACER_SIZE
  };
}

function keyRowStyle() {
  return {
    display: 'flex'
  };
}

function keyStyle({ styles, constants, color }) {
  const style = {
    ...styles.centerStyle,
    ...styles.fontStyle,
    flex: 1,
    height: constants.KEYFORM_KEY_HEIGHT,
    backgroundColor: color.white,
    color: color.black,
    boxSixing: 'border-box',
    borderRadius: constants.KEYFORM_KEY_HEIGHT / 2,
    fontSize: constants.KEYFORM_KEY_FONT_SIZE,
    cursor: 'pointer'
  };

  return style;
}

function submitStyle({ valid, styles, constants, color }) {
  const style = {
    ...styles.fontStyle,
    textAlign: 'center',
    height: constants.KEYFORM_BUTTON_HEIGHT,
    fontSize: constants.KEYFORM_BUTTON_FONT_SIZE,
    lineHeight: `${constants.KEYFORM_BUTTON_HEIGHT}px`,
    borderRadius: constants.KEYFORM_BUTTON_HEIGHT / 2,
    backgroundColor: valid ? color.blue['500'] : color.grey['200'],
    fontWeight: 900,
    color: valid ? color.white : color.grey['400'],
    paddingRight: constants.KEYFORM_BUTTON_PADDING_HORIZONTAL,
    paddingLeft: constants.KEYFORM_BUTTON_PADDING_HORIZONTAL,
    transition: `all 600ms ease-in-out`
  };

  return style;
}

export default props => (
  <div style={wrapperStyle(props)}>
    <div style={keyRowStyle(props)}>
      <div
        style={keyStyle(props)}
        role="button"
        onClick={() => props.add('1')}
        onKeyPress={() => props.add('1')}
        tabIndex={0}
      >
        1
      </div>
      <div style={squareStyle(props)} />
      <div
        style={keyStyle(props)}
        role="button"
        onClick={() => props.add('2')}
        onKeyPress={() => props.add('2')}
        tabIndex={0}
      >
        2
      </div>
      <div style={squareStyle(props)} />
      <div
        style={keyStyle(props)}
        role="button"
        onClick={() => props.add('3')}
        onKeyPress={() => props.add('3')}
        tabIndex={0}
      >
        3
      </div>
    </div>
    <div style={squareStyle(props)} />
    <div style={keyRowStyle(props)}>
      <div
        style={keyStyle(props)}
        role="button"
        onClick={() => props.add('4')}
        onKeyPress={() => props.add('4')}
        tabIndex={0}
      >
        4
      </div>
      <div style={squareStyle(props)} />
      <div
        style={keyStyle(props)}
        role="button"
        onClick={() => props.add('5')}
        onKeyPress={() => props.add('5')}
        tabIndex={0}
      >
        5
      </div>
      <div style={squareStyle(props)} />
      <div
        style={keyStyle(props)}
        role="button"
        onClick={() => props.add('6')}
        onKeyPress={() => props.add('6')}
        tabIndex={0}
      >
        6
      </div>
    </div>
    <div style={squareStyle(props)} />
    <div style={keyRowStyle(props)}>
      <div
        style={keyStyle(props)}
        role="button"
        onClick={() => props.add('7')}
        onKeyPress={() => props.add('7')}
        tabIndex={0}
      >
        7
      </div>
      <div style={squareStyle(props)} />
      <div
        style={keyStyle(props)}
        role="button"
        onClick={() => props.add('8')}
        onKeyPress={() => props.add('8')}
        tabIndex={0}
      >
        8
      </div>
      <div style={squareStyle(props)} />
      <div
        style={keyStyle(props)}
        role="button"
        onClick={() => props.add('9')}
        onKeyPress={() => props.add('9')}
        tabIndex={0}
      >
        9
      </div>
    </div>
    <div style={squareStyle(props)} />
    <div style={keyRowStyle(props)}>
      <div
        style={keyStyle(props)}
        role="button"
        onClick={props.clear}
        onKeyPress={props.clear}
        tabIndex={0}
      >
        <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </div>
      <div style={squareStyle(props)} />
      <div
        style={keyStyle(props)}
        role="button"
        onClick={() => props.add('0')}
        onKeyPress={() => props.add('0')}
        tabIndex={0}
      >
        0
      </div>
      <div style={squareStyle(props)} />
      <div
        style={keyStyle(props)}
        role="button"
        onClick={props.remove}
        onKeyPress={props.remove}
        tabIndex={0}
      >
        <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z" />
        </svg>
      </div>
    </div>
    <div style={squareStyle(props)} />
    <div style={squareStyle(props)} />
    <div
      style={submitStyle(props)}
      role="button"
      onClick={() => {
        if (props.valid) {
          props.submit(props.number);
        }
      }}
      onKeyPress={() => {
        if (props.valid) {
          props.submit(props.number);
        }
      }}
      tabIndex={0}
    >
      {props.text.SIGN_KEYFORM_SUBMIT}
    </div>
    <div style={squareStyle(props)} />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/KeyForm/index.js